/***
 * @Authors:
 *      Rahul
 ***/

/*** Imports ***/

/* Style imports */
import './styles2.css'

/* Library imports */
import React from "react";
import PropTypes from 'prop-types';

/* Component imports */

/*** End Imports ***/

const LoginHeader2 = props => {

    const {customStyleLoginPopupHeader, title, onClickCrossIcon, iconUrl, leftChildStyle, rightChildStyle} = props;
    return(
        <div className="login-popup-header" style={customStyleLoginPopupHeader}>
            <div className="lph-content" style={leftChildStyle}>{title}</div>
            {
                onClickCrossIcon ?
                <div className="lph-right-icon" onClick={onClickCrossIcon} style={rightChildStyle}>
                    <img src={iconUrl} />
                </div>
                :
                null
            }
            
        </div>
    );
};

LoginHeader2.propTypes = {
    showHeaderLftBtn: PropTypes.bool,
    showHeaderRgtBtn: PropTypes.bool,
    leftBtnClickListener: PropTypes.func,
    rightBtnClickListener: PropTypes.func,
    leftBtnMaterialIcon: PropTypes.string,
    rightBtnMaterialIcon: PropTypes.string,
    title: PropTypes.string.isRequired,
};

LoginHeader2.defaultProps = {
    showHeaderLftBtn: false,
    showHeaderRgtBtn: false
};

export default LoginHeader2;


// WEBPACK FOOTER //
// ./src/components/core/LoginHeader/LoginHeader2.js